import { NavLink, Outlet } from "react-router-dom";
import { Compass, MapTrifold, QrCode, Gift, User, ShieldCheck } from "@phosphor-icons/react";
import { useAuth } from "../../context/AuthContext";

const TABS = [
  { to: "/app", icon: Compass, label: "Discover", end: true },
  { to: "/app/map", icon: MapTrifold, label: "Map" },
  { to: "/app/pass", icon: QrCode, label: "Pass", pass: true },
  { to: "/app/rewards", icon: Gift, label: "Rewards" },
  { to: "/app/profile", icon: User, label: "Profile" },
];

export default function GuestShell() {
  const { user } = useAuth();
  const tabs = user?.role === "admin"
    ? [...TABS, { to: "/admin", icon: ShieldCheck, label: "Admin" }]
    : TABS;
  return (
    <div className="mx-auto min-h-screen max-w-[430px] border-x border-white/5 bg-[#050505] text-white"
      style={{ paddingTop: "env(safe-area-inset-top)" }}>
      <div className="pb-28">
        <Outlet />
      </div>
      <nav data-testid="guest-bottom-nav"
        className="glass fixed bottom-0 left-1/2 z-50 w-full max-w-[430px] -translate-x-1/2 border-x-0 border-b-0">
        <div className="flex items-end justify-around px-2 pt-2"
          style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}>
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={`nav-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                t.pass
                  ? "relative -top-5"
                  : `flex flex-col items-center gap-1 px-3 py-1 text-[10px] font-semibold uppercase tracking-wider transition-colors duration-200 ${isActive ? "text-neon-gold" : "text-zinc-500 hover:text-zinc-300"}`
              }>
              {({ isActive }) => (
                t.pass ? (
                  <span className={`flex h-16 w-16 items-center justify-center rounded-full border-2 ${isActive ? "border-neon-violet bg-neon-violet text-black shadow-glow-violet" : "border-neon-gold bg-neon-gold text-black shadow-glow-gold"} transition-[transform,box-shadow] duration-200 hover:scale-105`}>
                    <QrCode size={30} weight="bold" />
                  </span>
                ) : (
                  <>
                    <t.icon size={22} weight={isActive ? "fill" : "regular"} />
                    <span>{t.label}</span>
                  </>
                )
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
